function templateKey(item) {
  const label = String(item?.label ?? "").trim().toLowerCase();
  const value = String(item?.value ?? "").trim().toLowerCase();
  return { label, value };
}

/**
 * One questionnaire per distinct template. Same label or same value counts as
 * the same request, so a catalog row that appears twice still sends once.
 */
export function dedupeVqqTemplates(templates) {
  const seen = new Set();
  const result = [];
  for (const item of templates || []) {
    const { label, value } = templateKey(item);
    if (!label && !value) continue;
    if ((label && seen.has(`label:${label}`)) || (value && seen.has(`value:${value}`))) {
      continue;
    }
    if (label) seen.add(`label:${label}`);
    if (value) seen.add(`value:${value}`);
    result.push(item);
  }
  return result;
}
